 export enum DsnTypeEnvoi {
EnvoiNormal = 0,
EnvoiNeant = 1,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/DsnTypeEnvoi.ts